import React from 'react';

export default () => (
  <>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `
      {
          "@context": "https://schema.org/",
          "@type": "SoftwareApplication",
          "name": "Polypane browser for web developers who care",
          "operatingSystem": "Windows, Macos, Linux",
          "applicationCategory": "DeveloperApplication",
          "description": "A development browser for professional web developers. Build and test responsive, accessible websites with multi-viewport previews and accessibility tooling.",
          "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "ratingCount": "90"
        },
        "offers": {
            "@type": "AggregateOffer",
            "url": "https://polypane.app/pricing/",
            "priceCurrency": "USD",
            "lowPrice": "9",
            "highPrice": "320",
            "offerCount": "5"
          }
        }
  `,
      }}
    />
    <script
      type="application/ld+json"
      id="schema"
      dangerouslySetInnerHTML={{
        __html: `
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "url": "https://polypane.app",
      "logo": {
        "@type": "ImageObject",
        "url": "https://polypane.app/general/logo.png",
        "width": 5620,
        "height": 1200
      },
      "name": "Polypane",
      "legalName": "Polypane BV",
      "description": "A development browser for professional web developers. Build and test responsive, accessible websites with multi-viewport previews and accessibility tooling.",
      "foundingDate": "2019",
      "founders": [
        {
          "givenName": "Kilian",
          "familyName": "Valkhof"
        }
      ],
      "sameAs": [
        "https://bsky.app/profile/polypane.app",
        "https://www.linkedin.com/company/polypane",
        "https://www.instagram.com/polypane",
        "https://www.facebook.com/PolypaneBrowser",
        "https://x.com/polypane"
      ]
    }
  `,
      }}
    />
  </>
);
